import store from '@/store'
import Sounds from '@/js/sounds'
// import { get_card_value } from '@/js/board'

export const fire_scroll = (scroll, position) => {
	if (scroll && scroll.slug && actions[scroll.slug]) {
		const target = store.getters.game.hero.position === position ? store.getters.game.hero : store.getters.game.board.find(c => c.position === position)
		actions[scroll.slug](target ? target : position)
		Sounds.play('scroll')
	}
}


const actions = {

	// Inflige 3 dégâts au personnage ciblé.
	alteration: (target) => {
		store.dispatch('deal_damage', { victim: target, damage: 3 })
		// const life = target.life - 3
		// store.commit('EDIT_GAME_OBJ', { obj: target, life })
		// store.commit('EDIT_APP_STATE', { shaking: Date.now() })
		// store.dispatch('loot', { card: target })
	},

	// Confère poison 3 au personnage ciblé.
	poison: (target) => {
		store.dispatch('add_card_status', { card: target, status: 'poison', value: 3 })
	},

	// Confère force 3 au personnage ciblé.
	strength: (target) => {
		store.dispatch('add_card_status', { card: target, status: 'strength', value: 3 })
	},

	// Confère faiblesse 3 au personnage ciblé.
	weakness: (target) => {
		store.dispatch('add_card_status', { card: target, status: 'weakness', value: 3 })
	},

	// Soigne 3 PV au personnage ciblé.
	vitality: (target) => {
		const life = target.life + 3
		store.commit('EDIT_GAME_OBJ', { obj: target, life })
	},

	// Confère +1 durabilité aux équipements portés.
	repair: (target) => {
		if (target.equipments) {
			target.equipments.forEach((obj) => {
				store.commit('EDIT_GAME_OBJ', { obj, durability: obj.durability + 1 })
			})
		}
	},

	// Confère +2 durabilité à l'équipement ciblé.
	reinforcement: (target) => {
		if (target.durability) {
			store.commit('EDIT_GAME_OBJ', { obj: target, durability: target.durability + 2 })
		}
	},

	// Supprime l'effet passif d'un ennemi ciblé.
	mutism: (target) => {
		if (target.type === 'enemy' && target.triggers) {
			store.commit('EDIT_GAME_OBJ', { obj: target, triggers: [], passives: [] })
		}
	},

	// Confère +1 d'armure au bouclier ciblé.
	resistance: (target) => {
		console.log(target)
	},

	// Déplace l'ennemi ciblé vers la droite.
	wind: (target) => {
		store.dispatch('push_card', { card: target })
	},

}